import { render } from "./groovyEditor.vue?vue&type=template&id=61c2abfe"
import script from "./groovyEditor.vue?vue&type=script&lang=js"
export * from "./groovyEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__